import { withBemMod } from '@bem-react/core';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelMedia } from 'client/common/types';

import { cnLevel, ILevelProps } from '..';

import './level_type_media.css';

export interface ILevelMediaProps extends Omit<ILevelMedia, 'type'> {
    type?: 'media';
}

function constructNElements(n: number, Element: React.FC<{}>) {
    const elements = [];

    for (let i = 0; i < n; i++) {
        elements.push(<Element key={i} />);
    }

    return elements;
}

export const withLevelTypeMedia = withBemMod<ILevelMediaProps, ILevelProps>(
    cnLevel(),
    { type: 'media' },
    (BaseLevel: React.FC<ILevelProps>) => props => {

        const { title, subtitle, description, blocks, ...otherProps } = props;

        const blocksLength = blocks.length;

        const header: string[] = [];
        const body: Array<string | undefined> = [];
        const footer: string[] = [];

        blocks.forEach(({ topText, image, bottomText }) => {
            header.push(topText || '');
            body.push(image);
            footer.push(bottomText || '');
        });

        const scrollableMod = { scrollable: blocksLength > 1 };
        const sizeMod = { size: blocksLength };

        return (
            <BaseLevel {...otherProps}>
                <>
                    {title && (
                        <h2
                            className={cnLevel('title')}
                            dangerouslySetInnerHTML={{ __html: title }}
                            />
                    )}
                    {subtitle && (
                        <h3
                            className={cnLevel('subtitle')}
                            dangerouslySetInnerHTML={{ __html: subtitle }}
                            />
                    )}
                    {description && (
                        <HtmlContent
                            className={cnLevel('description')}
                            content={description}
                            />
                    )}
                    <div className={cnLevel('content', scrollableMod)}>
                        <div className={cnLevel('blocks', sizeMod)}>
                            {blocksLength > 1 && (
                                <div className={cnLevel('columns', sizeMod)}>
                                    {constructNElements(
                                        blocksLength, () => <div className={cnLevel('column')} />
                                    )}
                                </div>
                            )}
                            <div className={cnLevel('blocks-header')}>
                                <div className={cnLevel('row')}>
                                    {header.map(topText => (
                                        <HtmlContent
                                            key={topText}
                                            className={cnLevel('top-text')}
                                            content={topText}
                                            />
                                    ))}
                                </div>
                            </div>
                            <div className={cnLevel('blocks-body')}>
                                <div className={cnLevel('row')}>
                                    {body.map(imageSrc => (
                                        <div key={imageSrc} className={cnLevel('image')}>
                                            {imageSrc && <img src={imageSrc} alt="" />}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className={cnLevel('blocks-footer')}>
                                <div className={cnLevel('row')}>
                                    {footer.map(bottomText => (
                                        <HtmlContent
                                            key={bottomText}
                                            className={cnLevel('bottom-text')}
                                            content={bottomText}
                                            />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </BaseLevel>
        );
    }
);
